export const AUTH_URL = 'https://auth.pdlpapi.com/'
export const STAT_URL = 'https://stat.pdlpapi.com/'
export const SERVICE_URL = 'https://service.pdlpapi.com/'